import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { of, timer } from 'rxjs'
import { switchMap, delay, tap } from 'rxjs/operators'

@Injectable()
export class NgProgressService {
    minimum!: number
    speed!: number
    trickleSpeed: number = 10
    progress = 0

    /** Progress state */
    state$: Subject<any>
    /** Trickling stream */
    trickling$: Subject<any>

    constructor() {
        this.state$ = new Subject()
        this.trickling$ = new Subject()

        /** while progress is started keep emitting values */
        this.trickling$
            .pipe(
                switchMap(res => {
                    //console.log("in trickle" + this.trickleSpeed);

                    let timer$ = timer(0, this.trickleSpeed)
                    //timer$.takeWhile(() => this.isStarted()).pipe(tap((res2) => {
                    //  this.inc(res2)
                    //}));

                    timer$.pipe(
                        tap(res2 => {
                            this.inc(res2)
                        }),
                    )

                    return timer$
                }),
            )
            .subscribe(() => {})
    }

    /** Start */
    start() {
        if (!this.isStarted()) this.set(0)
        this.trickling$.next({})
    }

    /** Complete */
    done(forceReset: boolean = false) {
        /** if it hasn't already started don't complete the progress */
        if (!this.isStarted()) return
        //this.set(.3 + .5 * Math.random());
        this.set(1, forceReset)
    }

    /** Set progress state */
    set(n: number, forceReset: boolean = false) {
        this.progress = this.clamp(n, this.minimum, 1)
        this.updateState(this.progress, true)

        /** if progress completed */
        if (n === 1) {
            if (forceReset) {
                this.progress = 0
                this.updateState(this.progress, false)
            } else {
                /** complete then hide progressbar */
                const source = of(n)
                source
                    .pipe(
                        delay(500),
                        tap(() => {
                            /** reset progress */
                            this.progress = 0
                            this.updateState(this.progress, false)
                        }),
                    )
                    .subscribe()
            }
        }
    }

    /** Increment Progress */
    inc(amount: any) {
        //console.log("inc called");

        let n = this.progress
        /** if it hasn't start, start */
        if (!this.isStarted()) this.start()
        else {
            if (typeof amount !== 'number') {
                if (n >= 0 && n < 0.2) amount = 0.1
                else if (n >= 0.2 && n < 0.5) amount = 0.04
                else if (n >= 0.5 && n < 0.8) amount = 0.02
                else if (n >= 0.8 && n < 0.99) amount = 0.005
                else amount = 0
            }
            n = this.clamp(n + amount, 0, 0.994)
            this.set(n)
        }
    }

    /** Is progress started*/
    isStarted(): boolean {
        //console.log("this.progress: " + this.progress);
        //console.log("isStarted: " + (this.progress > 0 && this.progress < 1));
        return this.progress > 0 && this.progress < 1
    }

    /** Helper */
    clamp = (n: number, min: number, max: number) => {
        if (n < min) return min
        if (n > max) return max
        return n
    }

    /** Update Progressbar State */
    updateState(value: any, active: any) {
        let state = {
            value: value,
            active: active,
        }
        this.state$.next(state)
    }
}
